// extracted by mini-css-extract-plugin
module.exports = {"statsGrid":"SyncStatsOverview_statsGrid__3q5DT"};